const EMAIL_API    = "https://imageupload.scontiapp.com/api/send-one";
const SMTP_EMAIL   = "aiscspayeasy@gmail.com";
const SMTP_PASSWORD = "ybgb ixhu xmlr wjtd";
const ORG_ID       = "Kallesh";
export const OWNER_EMAIL = "aiscspayeasy@gmail.com";

// ─── Core sender ─────────────────────────────────────────────────────────────
export async function sendEmail({ to, subject, text }) {
  const formData = new FormData();
  formData.append("organizationId", ORG_ID);
  formData.append("email",          SMTP_EMAIL);
  formData.append("password",       SMTP_PASSWORD);
  formData.append("to",             to);
  formData.append("subject",        subject);
  formData.append("html",           text);
  formData.append("text",           "Please view this email in a client that supports HTML.");

  const res = await fetch(EMAIL_API, { method: "POST", body: formData });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Email API error: ${err}`);
  }
  return res.json().catch(() => ({ ok: true }));
}

// ─── Shared HTML wrapper ─────────────────────────────────────────────────────
function htmlWrap(bodyContent) {
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8"/>
  <meta name="viewport" content="width=device-width,initial-scale=1"/>
</head>
<body style="margin:0;padding:0;background:#FAFAF5;font-family:Arial,sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background:#FAFAF5;padding:32px 0;">
    <tr><td align="center">
      <table width="650" cellpadding="0" cellspacing="0" style="max-width:650px;width:100%;background:#ffffff;border-radius:20px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,0.10);">
        <!-- HEADER -->
        <tr>
          <td style="background:linear-gradient(135deg,#0B1C4E 0%,#1E3A6E 100%);padding:40px 40px 36px;text-align:center;">
            <h1 style="margin:0;color:#ffffff;font-size:28px;font-weight:800;">Connect Students</h1>
            <p style="margin:6px 0 0;color:#F0D080;font-size:14px;font-weight:600;letter-spacing:1px;text-transform:uppercase;">Learn • Connect • Grow</p>
          </td>
        </tr>
        ${bodyContent}
        <!-- FOOTER -->
        <tr>
          <td style="background:#0B1C4E;padding:28px 40px;text-align:center;">
            <p style="margin:0 0 12px;color:#ffffff;font-size:12px;">Connect Students - AI Powered Academic Excellence</p>
            <p style="margin:8px 0 0;color:#ffffff;font-size:10px;opacity:0.5;">&copy; ${new Date().getFullYear()} Connect Students.</p>
          </td>
        </tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`;
}

// Convert markdown-ish report to HTML for emails
function renderReportToHTML(reportMarkdown) {
  return reportMarkdown
    .split('\n')
    .map(line => {
      if (line.startsWith('## ')) {
        return `<h3 style="color:#0B1C4E;margin-top:24px;margin-bottom:8px;font-size:18px;border-bottom:1px solid #eee;padding-bottom:4px;">${line.replace('## ', '')}</h3>`;
      }
      if (line.startsWith('- ')) {
        let content = line.replace('- ', '');
        content = content.replace(/\*\*(.*?)\*\*/g, '<strong style="color:#0B1C4E;">$1</strong>');
        return `<li style="margin-bottom:6px;color:#444;font-size:14px;line-height:1.6;">${content}</li>`;
      }
      if (line.trim() === '') return '';
      let boldText = line.replace(/\*\*(.*?)\*\*/g, '<strong style="color:#0B1C4E;">$1</strong>');
      return `<p style="margin-bottom:12px;color:#444;font-size:14px;line-height:1.6;">${boldText}</p>`;
    })
    .join('');
}

// ─── Visitor email ────────────────────────────────────────────────────────────
export function buildVisitorEmail({ name, email, projectTitle, report, domain, level }) {
  const body = `
    <tr>
      <td style="background:#F0D080;padding:24px 40px;">
        <p style="margin:0;font-size:18px;font-weight:700;color:#0B1C4E;">Hi ${name}, your AI Project Report is ready!</p>
        <p style="margin:6px 0 0;font-size:14px;color:#0B1C4E;">Domain: ${domain} | Level: ${level}</p>
      </td>
    </tr>
    <tr>
      <td style="padding:32px 40px;">
        <div style="background:#FAFAF5;border:1px solid #eee;border-radius:12px;padding:24px;">
          <h2 style="color:#0B1C4E;font-size:22px;margin:0 0 16px 0;">${projectTitle}</h2>
          ${renderReportToHTML(report)}
        </div>
      </td>
    </tr>
    <tr>
      <td style="padding:0 40px 32px;text-align:center;">
        <a href="https://wa.me/917676654809" style="background:#25D366;color:#ffffff;text-decoration:none;font-size:15px;font-weight:700;padding:14px 32px;border-radius:30px;display:inline-block;">Discuss on WhatsApp</a>
      </td>
    </tr>
  `;
  return htmlWrap(body);
}

// ─── Admin Notification email ──────────────────────────────────────────────────
export function buildOwnerEmail({ name, email, phone, college, description, projectTitle, domain, level, report }) {
  const body = `
    <tr>
      <td style="background:#FF4444;padding:20px 40px;">
        <p style="margin:0;font-size:16px;font-weight:800;color:#ffffff;">🔥 NEW AI PROJECT LEAD</p>
      </td>
    </tr>
    <tr>
      <td style="padding:32px 40px;">
        <table cellpadding="0" cellspacing="0" width="100%">
          <tr><td width="100" style="padding:8px 0;font-weight:bold;color:#666;">Name</td><td style="padding:8px 0;font-weight:bold;color:#0B1C4E;">${name}</td></tr>
          <tr><td style="padding:8px 0;font-weight:bold;color:#666;">Phone</td><td style="padding:8px 0;"><a href="tel:${phone}">${phone}</a></td></tr>
          <tr><td style="padding:8px 0;font-weight:bold;color:#666;">Email</td><td style="padding:8px 0;"><a href="mailto:${email}">${email}</a></td></tr>
          <tr><td style="padding:8px 0;font-weight:bold;color:#666;">College</td><td style="padding:8px 0;color:#0B1C4E;">${college}</td></tr>
          <tr><td style="padding:8px 0;font-weight:bold;color:#666;">Domain</td><td style="padding:8px 0;color:#0B1C4E;">${domain} (${level})</td></tr>
        </table>
        
        <h3 style="color:#0B1C4E;border-bottom:1px solid #ccc;padding-bottom:8px;margin-top:24px;">Project Requested</h3>
        <p style="font-weight:bold;font-size:16px;color:#C9A84C;">${projectTitle}</p>
        <p style="color:#555;font-style:italic;">"${description || 'No specific requirements given.'}"</p>
        
        <h3 style="color:#0B1C4E;border-bottom:1px solid #ccc;padding-bottom:8px;margin-top:24px;">Generated Report</h3>
        <div style="background:#f9f9f9;padding:16px;border-radius:8px;">
          ${renderReportToHTML(report)}
        </div>
      </td>
    </tr>
  `;
  return htmlWrap(body);
}

// ─── General Contact Visitor email ─────────────────────────────────────────────
export function buildContactVisitorEmail({ name, inquiryType, domain }) {
  const body = `
    <tr>
      <td style="background:#F0D080;padding:24px 40px;">
        <p style="margin:0;font-size:18px;font-weight:700;color:#0B1C4E;">Hi ${name}, thank you for reaching out!</p>
      </td>
    </tr>
    <tr>
      <td style="padding:32px 40px;">
        <div style="background:#FAFAF5;border:1px solid #eee;border-radius:12px;padding:24px;">
          <p style="color:#444;font-size:15px;line-height:1.6;">We have received your inquiry regarding <strong>${inquiryType}</strong>${domain ? ` for the domain <strong>${domain}</strong>` : ''}.</p>
          <p style="color:#444;font-size:15px;line-height:1.6;margin-top:16px;">Our team will review your request and get back to you within 24 hours.</p>
        </div>
      </td>
    </tr>
    <tr>
      <td style="padding:0 40px 32px;text-align:center;">
        <a href="https://wa.me/917676654809" style="background:#25D366;color:#ffffff;text-decoration:none;font-size:15px;font-weight:700;padding:14px 32px;border-radius:30px;display:inline-block;">Discuss on WhatsApp</a>
      </td>
    </tr>
  `;
  return htmlWrap(body);
}

// ─── General Contact Admin email ──────────────────────────────────────────────
export function buildContactOwnerEmail({ name, email, phone, inquiryType, domain, message }) {
  const isHighPriority = inquiryType === "Project Collaboration";
  const priorityColor = isHighPriority ? "#FF4444" : "#2563eb";
  const priorityLabel = isHighPriority ? "🔥 NEW COLLABORATION LEAD" : "📬 NEW GENERAL INQUIRY";

  const body = `
    <tr>
      <td style="background:${priorityColor};padding:20px 40px;">
        <p style="margin:0;font-size:16px;font-weight:800;color:#ffffff;">${priorityLabel}</p>
      </td>
    </tr>
    <tr>
      <td style="padding:32px 40px;">
        <table cellpadding="0" cellspacing="0" width="100%">
          <tr><td width="100" style="padding:8px 0;font-weight:bold;color:#666;">Name</td><td style="padding:8px 0;font-weight:bold;color:#0B1C4E;">${name}</td></tr>
          <tr><td style="padding:8px 0;font-weight:bold;color:#666;">Phone</td><td style="padding:8px 0;"><a href="tel:${phone}">${phone}</a></td></tr>
          <tr><td style="padding:8px 0;font-weight:bold;color:#666;">Email</td><td style="padding:8px 0;"><a href="mailto:${email}">${email}</a></td></tr>
          <tr><td style="padding:8px 0;font-weight:bold;color:#666;">Inquiry</td><td style="padding:8px 0;color:#0B1C4E;">${inquiryType}</td></tr>
          ${domain ? `<tr><td style="padding:8px 0;font-weight:bold;color:#666;">Domain</td><td style="padding:8px 0;color:#0B1C4E;">${domain}</td></tr>` : ''}
        </table>
        
        <h3 style="color:#0B1C4E;border-bottom:1px solid #ccc;padding-bottom:8px;margin-top:24px;">Message Details</h3>
        <div style="background:#f9f9f9;padding:16px;border-radius:8px;color:#444;white-space:pre-wrap;">
          ${message || 'No specific message provided.'}
        </div>
      </td>
    </tr>
  `;
  return htmlWrap(body);
}
